export default function isEmailAddress(value) {
  if (!value) {
    return false;
  }
  return value.trim().match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g) !== null;
}
